/**
 * Application configuration
 */
import { primaryColor } from "../../build/config/themeConfig";
import { ThemeEnum } from "../enums/appEnum";
import type { ProjectConfig } from "/#/config";
import { PROJ_CFG_KEY } from "/@/enums/cacheEnum";
import { changeTheme } from "/@/logics/theme";
import { updateDarkTheme } from "/@/logics/theme/dark";
import { updateHeaderBgColor, updateSidebarBgColor } from "/@/logics/theme/updateBackground";
import { updateColorWeak } from "/@/logics/theme/updateColorWeak";
import { updateGrayMode } from "/@/logics/theme/updateGrayMode";
import projectSetting from "/@/settings/projectSetting";
import { appStore } from "/@/store/modules/app";
import { localeStore } from "/@/store/modules/locale";
import { deepMerge } from "/@/utils";
import { Persistent } from "/@/utils/cache/persistent";
import { getCommonStoragePrefix, getStorageShortName } from "/@/utils/env";

// Initial project configuration
export function initAppConfigStore() {
  let projCfg: ProjectConfig = Persistent.getLocal(PROJ_CFG_KEY) as ProjectConfig;
  // projCfg = deepMerge(projectSetting, projCfg || {});
  projCfg = projectSetting;
  const darkMode = appStore.getDarkMode;
  const {
    colorWeak,
    grayMode,
    themeColor,

    headerSetting: { bgColor: headerBgColor } = {},
    menuSetting: { bgColor } = {},
  } = projCfg;
  try {
    if (themeColor && themeColor !== primaryColor) {
      changeTheme(themeColor);
    }

    grayMode && updateGrayMode(grayMode);
    colorWeak && updateColorWeak(colorWeak);
  } catch (error) {
    console.log(error);
  }
  appStore.commitProjectConfigState(projCfg);

  // init dark mode
  updateDarkTheme(darkMode);
  if (darkMode === ThemeEnum.DARK) {
    updateHeaderBgColor();
    updateSidebarBgColor();
  } else {
    headerBgColor && updateHeaderBgColor(headerBgColor);
    bgColor && updateSidebarBgColor(bgColor);
  }
  // init store
  localeStore.initLocale();

  setTimeout(() => {
    clearObsoleteStorage();
  }, 16);
}

/**
 * As the version continues to iterate, there will be more and more cache keys stored in localStorage.
 * This method is used to delete useless keys
 */
export function clearObsoleteStorage() {
  const commonPrefix = getCommonStoragePrefix();
  const shortPrefix = getStorageShortName();

  [localStorage, sessionStorage].forEach((item: Storage) => {
    Object.keys(item).forEach((key) => {
      if (key && key.startsWith(commonPrefix) && !key.startsWith(shortPrefix)) {
        item.removeItem(key);
      }
    });
  });
}
